import { commentSchema } from '@/models/commentSchema';
import { pageableSchema } from '@/models/pageableSchema';
import { mapModelSchema } from '@/models/mapSchema';
import { apiPath } from '@/redux/apiPath';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Comment, MapModel, PageOf } from '@/types/models';
import { getError } from '@/utils/error-report/getError';

export const getProjectAllComments = createAsyncThunk<Comment[], string, ThunkConfig>(
  'comment/getProjectAllComments',
  async projectId => {
    try {
      const mapsResponse = await axiosInstanceNewAPI.get<PageOf<MapModel>>(
        apiPath.getProjectMaps(projectId),
      );
      const areMapsValid = validateDataUsingZodSchema(
        mapsResponse.data,
        pageableSchema(mapModelSchema),
      );
      const maps = areMapsValid ? mapsResponse.data.content : [];

      const commentsPerMap = await Promise.all(
        maps.map(async ({ id: mapId }) => {
          const response = await axiosInstanceNewAPI.get(apiPath.getMapComments(projectId, mapId));
          const isDataValid = validateDataUsingZodSchema(
            response.data,
            pageableSchema(commentSchema),
          );
          return isDataValid ? response.data.content : [];
        }),
      );

      return commentsPerMap.flat();
    } catch (error) {
      return Promise.reject(getError({ error }));
    }
  },
);
